import { TablePagination as MuiTablePagination, Pagination } from "@mui/material";
import {
  gridPageCountSelector,
  gridPageSelector,
  gridPageSizeSelector,
  gridPaginationRowCountSelector,
  useGridApiContext,
  useGridSelector
} from "@mui/x-data-grid-pro";
import { Theme } from "klayowebshared";

export const TablePagination = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const rowsPerPage = useGridSelector(apiRef, gridPageSizeSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  const count = useGridSelector(apiRef, gridPaginationRowCountSelector);

  return (
    <MuiTablePagination
      page={page}
      rowsPerPage={rowsPerPage}
      onPageChange={(event, value) => {
        apiRef.current.setPage(value);
      }}
      onRowsPerPageChange={(e) =>
        e.target.value && apiRef.current.setPageSize(Number(e.target.value))
      }
      count={count}
      ActionsComponent={(props) => {
        return (
          <div className={props.className}>
            <Pagination
              count={pageCount}
              page={props.page + 1}
              onChange={(event, value) => apiRef.current.setPage(value - 1)}
              sx={{
                "& .MuiPaginationItem-root.Mui-selected": {
                  color: Theme.getStyleVar("--grey-gr-050"),
                  backgroundColor: Theme.getStyleVar("--neon-blue-nb-500")
                }
              }}
            />
          </div>
        );
      }}
      sx={{
        "&.MuiTablePagination-root": {
          borderBottom: "unset"
        }
      }}
    />
  );
};
